import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IFLDocuments } from '../../documents-cercador/documents.interfaces';

@Injectable()
export class DocumentsService {
  private _API_BASE_URL: string = environment['API_URL'];

  public getActive(codi, tipus): Observable<any> {
    let params = new HttpParams();
 
    return this.authHttp.get(this._API_BASE_URL + 'documentspro/'+codi+'/tipus/'+tipus)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public createDocument(data): Observable<IFLDocuments> {
    return this.authHttp.post<any>(this._API_BASE_URL + 'documentspro', data)
      .pipe(map(response => response || {}));
  }

  public updateDocument(data): Observable<IFLDocuments> {
    return this.authHttp.put<any>(this._API_BASE_URL + 'documentspro', data)
      .pipe(map(response => response || {}));
  }

  public deleteDocument(id): Observable<IFLDocuments> {
    return this.authHttp.delete<any>(this._API_BASE_URL + 'documentspro/'+id)
      .pipe(map(response => response || {}));
  }

  constructor(protected authHttp: HttpClient) {}

}

